import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * Organizations API service
 */
export const OrganizationApi = {
  /**
   * Get all organizations (Admin only)
   * @returns {Promise<Response>} All organizations response
   */
  getOrganizations: async () => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/organizations`, {
      method: 'GET',
    });
  },

  /**
   * Get organization by ID (Admin only)
   * @param {string|number} id - Organization ID
   * @returns {Promise<Response>} Organization response
   */
  getOrganization: async (id) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/organizations/${id}`, {
      method: 'GET',
    });
  },

  /**
   * Create organization (Admin only)
   * @param {Object} data - Organization data
   * @returns {Promise<Response>} Create response
   */
  createOrganization: async (data) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/organizations`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(data),
    });
  },

  /**
   * Update organization (Admin only)
   * @param {string|number} id - Organization ID
   * @param {Object} data - Updated organization data
   * @returns {Promise<Response>} Update response
   */
  updateOrganization: async (id, data) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/organizations/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(data),
    });
  },

  /**
   * Delete organization (Admin only)
   * @param {string|number} id - Organization ID
   * @returns {Promise<Response>} Delete response
   */
  deleteOrganization: async (id) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/organizations/${id}`, {
      method: 'DELETE',
    });
  },

  /**
   * Get organization users (Admin only)
   * @param {string|number} organizationId - Organization ID
   * @returns {Promise<Response>} Organization users response
   */
  getOrganizationUsers: async (organizationId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/organizations/${organizationId}/users`, {
      method: 'GET',
    });
  }
};